import React from "react";
import { MerchantButton, RequestDetails, PageLoader } from "@components";
import { useNavigate, useOutletContext } from "react-router-dom";
import { PaymentAmount } from "../../shared/PaymentAmount";
import {
  PageTemplate,
  PageBody,
  PageFooter,
  Summary,
} from "./shared-components";

const PRConfirmDetails = () => {
  const {
    id,
    customerName,
    reference,
    files,
    merchant,
    statement,
    amountRequested,
    summaryData,
    settlementDiscount,
    flowId,
  } = useOutletContext();
  const navigate = useNavigate();

  // Destructure summary data from context
  const {
    invoiceTotal,
    invoiceCount,
    creditNoteTotal,
    creditNoteCount,
    totalToPay,
  } = summaryData;

  const goToPaymentMethod = () => navigate(`/${flowId}/${id}/paymentmethod`);

  const showLoader = !!statement;

  return (
    <PageTemplate className="flex flex-col lg:flex-row lg:h-screen lg:overflow-hidden">
      {showLoader ? (
        <PageBody>
          <div className="w-full h-full flex items-center justify-center">
            <PageLoader />
          </div>
        </PageBody>
      ) : (
        <>
          <PageBody>
            <div className="px-5 lg:px-0">
              <PaymentAmount amount={amountRequested} />
              <RequestDetails
                id={id}
                customerName={customerName}
                reference={reference}
                files={files}
              />
            </div>

            <div className="p-5 w-full mt-auto lg:hidden">
              <MerchantButton
                className=""
                onClick={goToPaymentMethod}
                merchant={merchant}
              >
                Confirm and continue
              </MerchantButton>
            </div>
          </PageBody>

          <PageFooter className="hidden lg:block">
            <div className="pb-7 space-y-2 hidden lg:block">
              <h2 className="text-xl font-medium">Payment summary</h2>
            </div>

            <Summary
              invoiceTotal={invoiceTotal}
              invoiceCount={invoiceCount}
              creditNoteTotal={creditNoteTotal}
              creditNoteCount={creditNoteCount}
              totalToPay={Math.max(0, totalToPay - settlementDiscount)}
              creditOnAccount={statement?.creditOnAccount || 0}
              hasStatement={!!statement}
              amountRequested={amountRequested}
              settlementDiscount={settlementDiscount}
            />

            <div className="pt-5">
              <MerchantButton
                className=""
                onClick={goToPaymentMethod}
                merchant={merchant}
              >
                Confirm and continue
              </MerchantButton>
            </div>
          </PageFooter>
        </>
      )}
    </PageTemplate>
  );
};

export default PRConfirmDetails;
